'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormContext, useWatch } from 'react-hook-form';
import RichText from '@/src/components/global/editor/RichText';
import Multilingual from '../global/Multilingual';
import { cx } from '@/src/styles/stylebook';
function TermRow(t0) {
  const $ = _c(34);
  const {
    term,
    hasError,
    rowIndex
  } = t0;
  const {
    register,
    control
  } = useFormContext();
  const isEvenRow = rowIndex % 2 === 0;
  const t1 = `terms.${term.key}`;
  let t2;
  if ($[0] !== control || $[1] !== t1) {
    t2 = {
      control,
      name: t1,
      defaultValue: false
    };
    $[0] = control;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isChecked = useWatch(t2);
  const t3 = isEvenRow ? "bg-gray-95" : "";
  let t4;
  if ($[3] !== t3) {
    t4 = cx("flex flex-row items-center justify-between px-5 py-3", t3, "max-md:flex-col max-md:items-start max-md:justify-start max-md:gap-3");
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cx("max-w-[calc(100%-180px)] flex-1", "max-md:max-w-full");
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== term.label) {
    t6 = <div className={t5}><div className="h6 text-gray-40 medium! flex flex-col leading-[1.7]"><div className="space-y-2"><p className="max-md:h6 font-semibold"><Multilingual>{term.label}</Multilingual></p></div></div></div>;
    $[6] = term.label;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cx("flex shrink-0 flex-row items-center justify-end gap-3 select-none", "max-md:w-full max-md:justify-start");
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `terms.${term.key}`;
  let t9;
  if ($[9] !== register || $[10] !== t8) {
    t9 = register(t8);
    $[9] = register;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <input type="checkbox" className="sr-only" {...t9} />;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = !isChecked && (isEvenRow ? "text-gray-40 bg-gray-100" : "bg-system-tilebg text-gray-40");
  const t12 = isChecked && "!bg-gray-0 !text-green-50";
  const t13 = hasError && "border-system-error border-2";
  let t14;
  if ($[14] !== t11 || $[15] !== t12 || $[16] !== t13) {
    t14 = cx("h6 bold min-w-36 cursor-pointer px-4 py-1.5 text-center leading-[1.7] transition-all duration-200", t11, t12, t13);
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const t15 = term.buttonLabel || (term.type === "consentText" ? "\uB3D9\uC758\uD569\uB2C8\uB2E4" : "\uD655\uC778\uD588\uC2B5\uB2C8\uB2E4");
  let t16;
  if ($[18] !== t14 || $[19] !== t15) {
    t16 = <span className={t14}>{t15}</span>;
    $[18] = t14;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t10 || $[22] !== t16) {
    t17 = <div className={t7}><label className="flex cursor-pointer items-center">{t10}{t16}</label></div>;
    $[21] = t10;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t17 || $[25] !== t4 || $[26] !== t6) {
    t18 = <div className={t4}>{t6}{t17}</div>;
    $[24] = t17;
    $[25] = t4;
    $[26] = t6;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== term.content || $[29] !== term.type) {
    t19 = term.type === "consentText" && term.content && <div className={cx("p medium px-marg py-gutter max-h-[30vh] max-w-[calc(100%-180px)] overflow-y-auto leading-[32px] text-gray-50", "max-md:py-gutter max-md:max-w-full")} data-lenis-prevent={true}><Multilingual><RichText value={term.content} /></Multilingual></div>;
    $[28] = term.content;
    $[29] = term.type;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t18 || $[32] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[31] = t18;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  return t20;
}
function CompactTermRow(t0) {
  const $ = _c(24);
  const {
    term,
    hasError
  } = t0;
  const {
    register,
    control
  } = useFormContext();
  const t1 = `terms.${term.key}`;
  let t2;
  if ($[0] !== control || $[1] !== t1) {
    t2 = {
      control,
      name: t1,
      defaultValue: false
    };
    $[0] = control;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useWatch(t2);
  const t3 = `terms.${term.key}`;
  let t4;
  if ($[3] !== register || $[4] !== t3) {
    t4 = register(t3);
    $[3] = register;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <input type="checkbox" className="mt-1 shrink-0" {...t4} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== term.label) {
    t6 = <span className="smallp font-medium">{term.label}</span>;
    $[8] = term.label;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== term.content || $[11] !== term.type) {
    t7 = term.type === "consentText" && term.content && <div className="mt-2 text-sm opacity-80"><RichText value={term.content} /></div>;
    $[10] = term.content;
    $[11] = term.type;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="flex-1">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <label className="flex cursor-pointer items-start gap-3">{t5}{t8}</label>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== hasError) {
    t10 = hasError && <span className="text-system-error ml-8 text-sm">필수 동의 항목입니다</span>;
    $[19] = hasError;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="flex flex-col gap-2">{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
export default function TermsSection(t0) {
  const $ = _c(33);
  const {
    terms,
    title: t1,
    showErrors: t2,
    className: t3,
    variant: t4
  } = t0;
  const title = t1 === undefined ? "\uC57D\uAD00 \uB3D9\uC758" : t1;
  const showErrors = t2 === undefined ? false : t2;
  const className = t3 === undefined ? "" : t3;
  const variant = t4 === undefined ? "default" : t4;
  const {
    control
  } = useFormContext();
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {};
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== control) {
    t6 = {
      control,
      name: "terms",
      defaultValue: t5
    };
    $[1] = control;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const termsState = useWatch(t6);
  if (variant === "compact") {
    const t7 = `${className}`;
    let t8;
    if ($[3] !== title) {
      t8 = title && <h5 className="h5 px-marg pb-2.5">{title}</h5>;
      $[3] = title;
      $[4] = t8;
    } else {
      t8 = $[4];
    }
    let t9;
    if ($[5] !== showErrors || $[6] !== terms || $[7] !== termsState) {
      let t10;
      if ($[9] !== showErrors || $[10] !== termsState) {
        t10 = term => <CompactTermRow key={term.key} term={term} hasError={showErrors && term.required && !termsState[term.key]} />;
        $[9] = showErrors;
        $[10] = termsState;
        $[11] = t10;
      } else {
        t10 = $[11];
      }
      t9 = terms.map(t10);
      $[5] = showErrors;
      $[6] = terms;
      $[7] = termsState;
      $[8] = t9;
    } else {
      t9 = $[8];
    }
    let t10;
    if ($[12] !== t9) {
      t10 = <div className="flex flex-col gap-4">{t9}</div>;
      $[12] = t9;
      $[13] = t10;
    } else {
      t10 = $[13];
    }
    let t11;
    if ($[14] !== t10 || $[15] !== t7 || $[16] !== t8) {
      t11 = <div className={t7}>{t8}{t10}</div>;
      $[14] = t10;
      $[15] = t7;
      $[16] = t8;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    return t11;
  }
  const t7 = `${className}`;
  let t8;
  if ($[18] !== title) {
    t8 = title && <h5 className="h5 px-marg pb-2.5">{title}</h5>;
    $[18] = title;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== showErrors || $[21] !== terms || $[22] !== termsState) {
    let t10;
    if ($[24] !== showErrors || $[25] !== termsState) {
      t10 = (term_0, index) => <TermRow key={term_0.key} term={term_0} hasError={showErrors && term_0.required && !termsState[term_0.key]} rowIndex={index} />;
      $[24] = showErrors;
      $[25] = termsState;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    t9 = terms.map(t10);
    $[20] = showErrors;
    $[21] = terms;
    $[22] = termsState;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[27] !== t9) {
    t10 = <div className="flex flex-col overflow-hidden">{t9}</div>;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t7 || $[31] !== t8) {
    t11 = <div className={t7}>{t8}{t10}</div>;
    $[29] = t10;
    $[30] = t7;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}